module.exports = __webpack_public_path__ + "img/background.4ed901a1.jpg";